import {getReportParams, report} from '../../../../middleware/report';

export function dwhValidateStepDisplay({selectedHetPay, customerName, subscriber}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'BusinessDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Subscriber Search Page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Subscriber Search Page Displayed';
  reportParams.subscriber = subscriber;
  reportParams.param1 = selectedHetPay;
  reportParams.customerName = customerName;

  report(reportParams);
}
export function dwhValidateStepButtonClick({selectedHetPay, customerName, subscriber, dwhParam}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'BusinessDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Subscriber Search Page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Subscriber Search Page Button Clicked';
  reportParams.subscriber = subscriber;
  reportParams.param1 = selectedHetPay;
  reportParams.param10 = dwhParam;
  reportParams.customerName = customerName;

  report(reportParams);
}
export function dwhAccountNotFoundError({selectedHetPay, customerName, subscriber, dwhParam}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'BusinessDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Subscriber Search Page';
  reportParams.status = 'Completed';
  reportParams.messageText = 'Subscriber Not Found';
  reportParams.subscriber = subscriber;
  reportParams.param1 = selectedHetPay;
  reportParams.param10 = dwhParam;
  reportParams.customerName = customerName;

  report(reportParams);
}
export function dwhGeneralErrorOnValidate({selectedHetPay, customerName, subscriber, dwhParam, step}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'BusinessDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Subscriber Search Page';
  reportParams.status = 'Error';
  reportParams.messageText = 'General Error';
  reportParams.subscriber = subscriber;
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = step;
  reportParams.param10 = dwhParam;
  reportParams.customerName = customerName;

  report(reportParams);
}
export function dwhAssociatedWithAnotherOrgError({selectedHetPay, customerName, subscriber, dwhParam}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'BusinessDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Subscriber Search Page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Subscriber associated with another business account';
  reportParams.subscriber = subscriber;
  reportParams.param1 = selectedHetPay;
  reportParams.param10 = dwhParam;
  reportParams.customerName = customerName;

  report(reportParams);
}
export function dwhIMEISelectionPageDisplay({selectedHetPay, customerName, subscriber, phone}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'BusinessDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'IMEI selection';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'IMEI selection Page Displayed';
  reportParams.subscriber = subscriber;
  reportParams.param1 = selectedHetPay;
  reportParams.param10 = phone;
  reportParams.customerName = customerName;

  report(reportParams);
}
export function dwhCauseSelectionPageDisplay({selectedHetPay, customerName, subscriber, phone}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'BusinessDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Selecting a fault type screen';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Selecting a fault type screen Page Displayed';
  reportParams.subscriber = subscriber;
  reportParams.param10 = phone;
  reportParams.param1 = selectedHetPay;
  reportParams.customerName = customerName;

  report(reportParams);
}
export function dwhCauseSelectionButtonClick({selectedHetPay, customerName, subscriber, phone, param2, param3}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'BusinessDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Selecting a fault type screen';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Selecting a fault type screen Button Clicked';
  reportParams.subscriber = subscriber;
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = param2;
  reportParams.param3 = param3;
  reportParams.param10 = phone;
  reportParams.customerName = customerName;

  report(reportParams);
}
export function dwhCauseSelectionGeneralError({selectedHetPay, customerName, subscriber, phone, param2, param3}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'BusinessDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Selecting a fault type screen';
  reportParams.status = 'Error';
  reportParams.messageText = 'General Error';
  reportParams.subscriber = subscriber;
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = param2;
  reportParams.param3 = param3;
  reportParams.param10 = phone;
  reportParams.customerName = customerName;

  report(reportParams);
}
export function dwhDeliveryAddressPageDisplayed({selectedHetPay, customerName, subscriber, phone, param2, param3}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'BusinessDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Delivery address page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Delivery address page Displayed';
  reportParams.subscriber = subscriber;
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = param2;
  reportParams.param3 = param3;
  reportParams.param10 = phone;
  reportParams.customerName = customerName;

  report(reportParams);
}
export function dwhDeliveryAddressButtonClick({selectedHetPay, customerName, subscriber, phone, param2, param3}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'BusinessDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Delivery address page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Delivery address button clicked';
  reportParams.subscriber = subscriber;
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = param2;
  reportParams.param3 = param3;
  reportParams.param10 = phone;
  reportParams.customerName = customerName;

  report(reportParams);
}
export function dwhDeliveryAddressAndDatePageDisplayed({selectedHetPay, customerName, subscriber, phone, param2, param3}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'BusinessDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Delivery address and date page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Delivery address and date page displayed';
  reportParams.subscriber = subscriber;
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = param2;
  reportParams.param3 = param3;
  reportParams.param10 = phone;
  reportParams.customerName = customerName;

  report(reportParams);
}
export function dwhDeliveryAddressAndDateButtonClick({selectedHetPay, customerName, subscriber, phone, param2, param3}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'BusinessDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Delivery address and date page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Delivery address and date button clicked';
  reportParams.subscriber = subscriber;
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = param2;
  reportParams.param3 = param3;
  reportParams.param10 = phone;
  reportParams.customerName = customerName;

  report(reportParams);
}
export function dwhCreateDeliveryNotificationError({selectedHetPay, customerName, subscriber, phone, param2, param3}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'BusinessDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Delivery address and date page';
  reportParams.status = 'Error';
  reportParams.messageText = 'General Error';
  reportParams.subscriber = subscriber;
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = param2;
  reportParams.param3 = param3;
  reportParams.param10 = phone;
  reportParams.customerName = customerName;

  report(reportParams);
}
export function dwhCompleted({selectedHetPay, customerName, subscriber, phone, param2,param3,businessDetails}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'BusinessDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Delivery address and date page';
  reportParams.status = 'Completed';
  reportParams.messageText = 'Success';
  reportParams.subscriber = subscriber;
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = param2;
  reportParams.param3 = param3;
  reportParams.param10 = phone;
  reportParams.customerName = customerName;
  reportParams.businessDetails = businessDetails;
  report(reportParams);
}

//IDF
export function dwhIDFIMEISelectionPageDisplay({customerName, subscriber}){
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'IDFDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'IMEI selection';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'IMEI selection Page Displayed';
  reportParams.subscriber = subscriber;
  reportParams.param1 = subscriber;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhIDFCauseSelectionPageDisplay({customerName, subscriber, param2, param3}){
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'IDFDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'IMEI selection';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Selecting a fault type screen Page Displayed';
  reportParams.subscriber = subscriber;
  reportParams.param1 = subscriber;
  reportParams.param2 = param2;
  reportParams.param3 = param3;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhIDFCauseSelectionButtonClick({customerName, subscriber, param2,param3}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'IDFDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Selecting a fault type screen';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Selecting a fault type screen Button Clicked';
  reportParams.subscriber = subscriber;
  reportParams.param1 = subscriber;
  reportParams.param2 = param2;
  reportParams.param3 = param3;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhIDFCauseSelectionGeneralError({customerName, subscriber, param2,param3}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'IDFDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Selecting a fault type screen';
  reportParams.status = 'Error';
  reportParams.messageText = 'General Error';
  reportParams.subscriber = subscriber;
  reportParams.param1 = subscriber;
  reportParams.param2 = param2;
  reportParams.param3 = param3;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhIDFDeliveryAddressAndDateButtonClick({customerName, subscriber, param2,param3}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'IDFDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Delivery address page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Delivery address button clicked';
  reportParams.subscriber = subscriber;
  reportParams.param1 = subscriber;
  reportParams.param2 = param2;
  reportParams.param3 = param3;
  reportParams.customerName = customerName;

  report(reportParams);
}
export function dwhIDFDeliveryAddressAndDatePageDisplayed({customerName, subscriber, param2,param3}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'IDFDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Delivery address and date page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Delivery address and date page displayed';
  reportParams.subscriber = subscriber;
  reportParams.param1 = subscriber;
  reportParams.param2 = param2;
  reportParams.param3 = param3;
  reportParams.customerName = customerName;

  report(reportParams);
}
export function dwhIDFCreateDeliveryNotificationError({customerName, subscriber, param2,param3}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'IDFDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Delivery address and date page';
  reportParams.status = 'Error';
  reportParams.messageText = 'General Error';
  reportParams.subscriber = subscriber;
  reportParams.param1 = subscriber;
  reportParams.param2 = param2;
  reportParams.param3 = param3;
  reportParams.customerName = customerName;

  report(reportParams);
}
export function dwhIDFCompleted({customerName, subscriber, param2,param3}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'IDFDeliveryDeviceRepair';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Delivery address and date page';
  reportParams.status = 'Completed';
  reportParams.messageText = 'Success';
  reportParams.subscriber = subscriber;
  reportParams.param1 = phone;
  reportParams.param2 = param2;
  reportParams.param3 = param3;
  reportParams.param10 = selectedHetPay;
  reportParams.customerName = customerName;

  report(reportParams);
}

//Private
export function dwhPrivateIMEIPageDisplayed({selectedHetPay, subscriber, customerName, orgName}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'DeliveryDeviceRepairSubscriber';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'IMEI Page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'IMEI Page Displayed';
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = subscriber;
  reportParams.param8 = orgName;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhPrivateIMEIPageButtonClick({selectedHetPay, subscriber, IMEI, customerName, orgName}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'DeliveryDeviceRepairSubscriber';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'IMEI Page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'IMEI Page Button Clicked';
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = subscriber;
  reportParams.param3 = IMEI;
  reportParams.param8 = orgName;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhPrivateErrorNoRepairServiceForDevice({selectedHetPay, subscriber, IMEI, customerName, orgName}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'DeliveryDeviceRepairSubscriber';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Error Screen';
  reportParams.status = 'Error';
  reportParams.messageText = 'Error Screen - No Repair service For device';
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = subscriber;
  reportParams.param3 = IMEI;
  reportParams.param8 = orgName;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhPrivateErrorNoRepairServiceForUser({selectedHetPay, subscriber, IMEI, customerName, orgName}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'DeliveryDeviceRepairSubscriber';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Error Screen';
  reportParams.status = 'Error';
  reportParams.messageText = 'Error Screen - No Repair service For User';
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = subscriber;
  reportParams.param3 = IMEI;
  reportParams.param8 = orgName;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhPrivateFMIPPageDisplayed({selectedHetPay, subscriber, IMEI, customerName, orgName}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'DeliveryDeviceRepairSubscriber';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'FMIP Page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'FMIP Page Displayed';
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = subscriber;
  reportParams.param3 = IMEI;
  reportParams.param8 = orgName;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhPrivateTechnicalMalfunctionPageDisplayed({selectedHetPay, subscriber, IMEI, customerName, orgName}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'DeliveryDeviceRepairSubscriber';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Technical malfunction Page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Technical malfunction Page Displayed';
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = subscriber;
  reportParams.param3 = IMEI;
  reportParams.param8 = orgName;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhPrivateTechnicalMalfunctionPageButtonClick({selectedHetPay, subscriber, IMEI, faults, provideReplacementDevice, lockscreenCode, customerName, orgName}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'DeliveryDeviceRepairSubscriber';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Technical malfunction Page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Technical malfunction Page Button Clicked';
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = subscriber;
  reportParams.param3 = IMEI;
  reportParams.param4 = faults;
  reportParams.param5 = provideReplacementDevice;
  reportParams.param6 = lockscreenCode;
  reportParams.param8 = orgName;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhPrivateDeliveryAddressPageDisplayed({selectedHetPay, subscriber, IMEI, faults, provideReplacementDevice, lockscreenCode, deliveryPrice, customerName, orgName}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'DeliveryDeviceRepairSubscriber';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Delivery address page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Delivery address page Displayed';
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = subscriber;
  reportParams.param3 = IMEI;
  reportParams.param4 = faults;
  reportParams.param5 = provideReplacementDevice;
  reportParams.param6 = lockscreenCode;
  reportParams.param7 = deliveryPrice;
  reportParams.param8 = orgName;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhPrivateDeliveryAddressPageButtonClick({selectedHetPay, subscriber, IMEI, faults, provideReplacementDevice, lockscreenCode, deliveryPrice, customerName, orgName}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'DeliveryDeviceRepairSubscriber';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Delivery address page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Delivery address page Button Clicked';
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = subscriber;
  reportParams.param3 = IMEI;
  reportParams.param4 = faults;
  reportParams.param5 = provideReplacementDevice;
  reportParams.param6 = lockscreenCode;
  reportParams.param7 = deliveryPrice;
  reportParams.param8 = orgName;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhPrivateReturnAddressPageDisplayed({selectedHetPay, subscriber, IMEI, faults, provideReplacementDevice, lockscreenCode, deliveryPrice, customerName, orgName}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'DeliveryDeviceRepairSubscriber';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Return address page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Return address page Displayed';
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = subscriber;
  reportParams.param3 = IMEI;
  reportParams.param4 = faults;
  reportParams.param5 = provideReplacementDevice;
  reportParams.param6 = lockscreenCode;
  reportParams.param7 = deliveryPrice;
  reportParams.param8 = orgName;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhPrivateReturnAddressPageButtonClick({selectedHetPay, subscriber, IMEI, faults, provideReplacementDevice, lockscreenCode, deliveryPrice, customerName, orgName}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'DeliveryDeviceRepairSubscriber';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Return address page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'Return address page Button Clicked';
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = subscriber;
  reportParams.param3 = IMEI;
  reportParams.param4 = faults;
  reportParams.param5 = provideReplacementDevice;
  reportParams.param6 = lockscreenCode;
  reportParams.param7 = deliveryPrice;
  reportParams.param8 = orgName;
  reportParams.customerName = customerName;
  report(reportParams);
}
export function dwhPrivateSuccessScreenDisplayed({selectedHetPay, subscriber, IMEI, faults, provideReplacementDevice, lockscreenCode, deliveryPrice, customerName, orgName, businessDetails}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'DeliveryDeviceRepairSubscriber';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Success Screen';
  reportParams.status = 'Completed';
  reportParams.messageText = 'Success Screen';
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = subscriber;
  reportParams.param3 = IMEI;
  reportParams.param4 = faults;
  reportParams.param5 = provideReplacementDevice;
  reportParams.param6 = lockscreenCode;
  reportParams.param7 = deliveryPrice;
  reportParams.param8 = orgName;
  reportParams.subscriber = subscriber;
  reportParams.customerName = customerName;
  reportParams.businessDetails = businessDetails;
  report(reportParams);
}
export function dwhPrivateGeneralErrorScreenDisplayed({selectedHetPay, subscriber, IMEI, faults, provideReplacementDevice, lockscreenCode, deliveryPrice, customerName, orgName}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'DeliveryDeviceRepairSubscriber';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = 'Error Screen';
  reportParams.status = 'Error';
  reportParams.messageText = 'General Error';
  reportParams.param1 = selectedHetPay;
  reportParams.param2 = subscriber;
  reportParams.param3 = IMEI;
  reportParams.param4 = faults;
  reportParams.param5 = provideReplacementDevice;
  reportParams.param6 = lockscreenCode;
  reportParams.param7 = deliveryPrice;
  reportParams.param8 = orgName;
  reportParams.customerName = customerName;
  report(reportParams);
}
